export function foreverInvalid(c) {
  return {
    foreverInvalid: {
      valid: false
    }
  };
}
export const FOREVER_INVALID_NAME = 'foreverInvalid';